<template>
  <div class="box">
    <v-head :title="title"></v-head>
    <div class="content">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import vHead from "../../components/Subhead.vue";
export default {
  data() {
    return {
      active: 0,
      statues: 2,
      title:"账号注册"
    };
  },
  components: {
    vHead
  },
  methods: {
    go(type) {
      this.$router.push({ name: type });
    }
  }
};
</script>

<style lang="less" scoped>
.header {
  height: 200px;
   background: url("../../assets/images/black.jpg") 0 0;
  .logo {
    padding-top: 50px;
    img {
      display: block;
      width: 70px;
      height: 70px;
      margin: 0 auto;
    }
  }
}
.content {
  padding: 26px 25px;
}
.login-box {
  position: fixed;
  font-size: 14px;
  left: 50%;
  transform: translateX(-50%);
  bottom: 0;
  span {
    color: #228ccd;
  }
}
.btn-box{ text-align: center; margin-top: 26px; color: #fff; font-size: 16px; }
</style>
